"use strict";

import $ from "jquery";

class SelectFilters
{
    constructor(filters, delegate, options) {
        this.options = Object.assign({}, {
            onChange: null
        }, options);

        // Required.
        if ((this.delegate = $(delegate)).length < 1) {
            return;
        }

        this.listen(filters);
    }

    listen(filters) {
        this.delegate.on("change", filters, (event) => {
            event.preventDefault();

            const $this = $(event.currentTarget);
            const $selected = $this.find(":selected");

            let value = $selected.data("slug");
            if ($selected.data("isarray") === "yes") {
                value = [$selected.data("slug")];
            }

            if (typeof this.options.onChange === 'function') {
                this.options.onChange($selected.data("filter"), value);
            }
        });
    }
}

export default SelectFilters;
